import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import { importVendorsModalSlice, ImportVendorsModalState } from '@REDUCERS';

function createImportVendorsModalHook() {
    return function useImportVendorsModal(equalityFn?: EqualityFn<ImportVendorsModalState>) {
        const state = useAppSelector((store) => store.importVendorsModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: () => dispatch(importVendorsModalSlice.actions.open()),
            close: () => dispatch(importVendorsModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

const useImportVendorsModal = createImportVendorsModalHook();

export default useImportVendorsModal; 